/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  z-index: var(--z-popup-menu);
  background-color: var(--cds-background);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  width: 300px;
  height: 200px;
`;

export const Header = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-bottom: 1px solid var(--cds-spacing-05);
  cursor: grab;
`;

export const HeaderLeft = styled.div`
  margin: var(--cds-spacing-04);
  display: flex;
  align-items: center;
  user-select: none;
`;

export const HeaderRight = styled.div`
  margin: 0;
  margin-inline-start: var(--cds-spacing-04);
  display: flex;
  align-items: center;
`;

export const HeaderLinks = styled.div`
  display: flex;
  align-items: center;
  gap: var(--cds-spacing-03);
`;

export const Title = styled.h2`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: var(--cds-spacing-06);
  margin-left: var(--cds-spacing-03);
`;

export const Content = styled.div`
  height: calc(100% - 40px);
  flex: 1;
`;

export const ResizeHandle = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 15px;
  height: 15px;
  cursor: se-resize;

  &::after {
    content: '';
    position: absolute;
    right: 4px;
    bottom: 4px;
    width: 10px;
    height: 10px;
    border-right: 2px solid var(--cds-border-strong);
    border-bottom: 2px solid var(--cds-border-strong);
  }
`;
